import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import dayjs from 'dayjs';
import { LoggerService } from 'src/services/logger.service';

@Pipe({
  name: 'dayDiff',
  standalone: false
})
export class DayDifferencePipe implements PipeTransform {
  private translate = inject(TranslateService);
  private loggerService = inject(LoggerService);

  public transform(endDateStr?: string, startDateStr?: string): string {
    // if startDate not provided, will be compared to now
    const startDate = startDateStr ? dayjs(startDateStr) : dayjs();
    const endDate = dayjs(endDateStr);

    if (!endDateStr || startDate.isAfter(endDate)) {
      this.loggerService.error('Failed to get dayDiff value!', { startDateStr, endDateStr });
      return 'N/A';
    }

    // If 0 days => give hours, if hours 0 as well => give minutes
    const daysDiff = endDate.diff(startDate, 'day');
    if (daysDiff === 0) {
      const hoursDiff = endDate.diff(startDate, 'hour');
      const minuteDiff = endDate.diff(startDate, 'minute');
      if (hoursDiff === 0) {
        return this.handleUnitDiff(minuteDiff, 'minute');
      }
      return this.handleUnitDiff(hoursDiff, 'hour');
    }
    return this.handleUnitDiff(daysDiff, 'day');
  }

  private handleUnitDiff(diff: number, unit: 'day' | 'hour' | 'minute' ) {
    let translatePrefix = '';

    if (diff === 1) {
      translatePrefix = '1';
    } else if ((diff >= 2) && (diff <= 4)) {
      translatePrefix = '2to4';
    } else {
      translatePrefix = '5';
    }

    return diff + '\u00A0' + this.translate.instant(`dayDiffPipe.${translatePrefix}.${unit}`);
  }

}
